import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 text-center">
        <p className="text-sm text-neutral-light">© 2025 Sit Side. Connecting students with families in need of childcare.</p>
        <p className="mt-2 text-xs text-neutral-light">SitSide is not affiliated with any school or district.</p>
      </div>
    </footer>
  );
};

export default Footer;

